(function () {
  function hoverMainMenu() {
    var self = this;
    this.init = function (obj, e) {
      var subMenu = $('#' + obj.dataset.child);
      var mainMenu = $('.' + obj.dataset.parent);

      console.log({ subMenu, mainMenu, child: obj.dataset.child, parent: obj.dataset.parent });

      this.obeserveNav(subMenu);
      var imageCategory = $('.submenu-wrap.open').find('.image-wrap .image_menu_container');
      var defaultMedia = imageCategory.attr('default_image');
      imageCategory.css('background-image', 'url(' + defaultMedia + ')');
      if (this.checkIfExist(subMenu)) {
        this.openSubMenu(subMenu, mainMenu);
      } else {
        this.clearAllMenu();
      }
    };

    this.clearAllMenu = function () {
      $('.linktoactive').each(function () {
        $(this).removeClass('current');
      });
      $('.main_menu_link > a, .main_menu_link > button.main_menu_link_item').removeClass('current');

      $('.main_menu_toggle').attr('aria-expanded', 'false');
      $('.submenu-wrap').attr('aria-hidden', 'true');

      $('.submenu-wrap').each(function () {
        $(this).find('.submenu').addClass('invisible');
        $(this).find('.op').addClass('hide');
        $(this).addClass('hide');
        $(this).removeClass('open');
      });
    };

    this.openSubMenu = function (submenu, mainMenu) {
      if (submenu.hasClass('open')) return;
      this.clearAllMenu();

      mainMenu.children('.main_menu_toggle').attr('aria-expanded', 'true');
      submenu.attr('aria-hidden', 'false');

      mainMenu.children('a, button.main_menu_link_item').addClass('current');
      submenu.addClass('open');
      submenu.removeClass('hide');
      submenu.find('.submenu_lvl0').removeClass('invisible');
      submenu.find('.image-wrap').removeClass('invisible');

      var level2Links = submenu.find('.submenu_lvl0').find('.submenu_link');
      if (level2Links.length) {
        level2Links.first().trigger('open.menu.oc');
      }
    };

    this.checkIfExist = function (submenu) {
      if (submenu[0]) {
        return true;
      }
      return false;
    };

    this.obeserveNav = function (obj) {
      $(obj)
        .mouseenter(function () {})
        .mouseleave(function () {
          self.clearAllMenu();
        });
    };
  }

  var menuHandler = new hoverMainMenu();
  let isHovered = false;

  $('.main_menu_link').on('mouseenter', function (e) {
    isHovered = true;
  });

  $('.main_menu_link').on('mouseleave', function (e) {
    isHovered = false;
  });

  $('.main_menu_link').on('mouseenter', function (e) {
    const menu_mobile = 1375;
    const _this = this;

    setTimeout(function () {
      if (jQuery(window).outerWidth(true) > menu_mobile && isHovered) {
        menuHandler.init(_this, e);
      }
    }, 300);
  });

  $('.main_menu_toggle').on('click', function (e) {
    if (jQuery(window).outerWidth(true) <= 1375) return;

    e.preventDefault();

    var toggle = $(this);
    var subMenu = $('#' + toggle.attr('data-child'));

    if (subMenu.hasClass('open')) {
      menuHandler.clearAllMenu();
      toggle.focus();
      return;
    }

    menuHandler.init(toggle.closest('.main_menu_link')[0], e);
  });

  $(document).on('keydown', function (e) {
    if (e.key === 'Escape') {
      var currentSubmenu = $(document.activeElement).closest('.submenu-wrap[id]');
      var trigger = $();

      if (currentSubmenu.length) {
        trigger = $('.main_menu_link[data-child="' + currentSubmenu.attr('id') + '"] > .main_menu_toggle').first();
      }

      menuHandler.clearAllMenu();

      if (trigger.length) {
        e.preventDefault();
        trigger.focus();
      }
    }
  });

  $('body').on('focusin', function (e) {
    if ($(e.target).closest('.header-menu, .main-menu').length === 0) {
      menuHandler.clearAllMenu();
    }
  });
})();

$(document).ready(function () {
  $('.main_menu_link > .main_menu_toggle').on('keydown', function (e) {
    if (e.key === 'Tab' && !e.shiftKey) {
      var parentLi = $(this).closest('.main_menu_link');
      var childId = parentLi.attr('data-child');
      var subMenu = $('#' + childId);

      if (subMenu.length > 0 && subMenu.hasClass('open')) {
        e.preventDefault();
        var firstLink = subMenu.find('a:visible').first();
        firstLink.focus();
      }
    }
  });

  $('.submenu-wrap').each(function () {
    var submenu = $(this);
    var allLinks = submenu.find('a');

    if (allLinks.length === 0) return;

    var lastLink = allLinks.last();
    var firstLink = allLinks.first();

    lastLink.on('keydown', function (e) {
      if ($(this).is(':visible') && e.key === 'Tab' && !e.shiftKey) {
        var menuId = submenu.attr('id');
        var parentTrigger = $('.main_menu_link[data-child="' + menuId + '"]');

        var nextMainLi = parentTrigger.nextAll('.main_menu_link').first();
        var nextMainLink = nextMainLi.children('a.main_menu_link_item, button.main_menu_link_item').first();

        if (nextMainLink.length > 0) {
          e.preventDefault();
          nextMainLink.focus();
        } else {
          var menuContainer = $('.menu-wrap');
          var nextContainer = menuContainer.next();
          var targetElement = nextContainer.find('a, button, input').filter(':visible').first();

          if (targetElement.length > 0) {
            e.preventDefault();
            targetElement.focus();

            $('.submenu-wrap').removeClass('open').addClass('hide').attr('aria-hidden', 'true');
            $('.main_menu_toggle').attr('aria-expanded', 'false');
          }
        }
      }
    });

    firstLink.on('keydown', function (e) {
      if ($(this).is(':visible') && e.key === 'Tab' && e.shiftKey) {
        var menuId = submenu.attr('id');
        var parentTriggerLink = $('.main_menu_link[data-child="' + menuId + '"] > .main_menu_toggle').first();

        if (parentTriggerLink.length > 0) {
          e.preventDefault();
          parentTriggerLink.focus();
        }
      }
    });
  });
});
